export default function getTexts({ __ }) {
    return {
        addFilterBtnText: __('+ Add Filter', 'air-wp-sync'),
        addFilterGroupBtnText: __('+ Add Filter Group', 'air-wp-sync'),
        where: __('Where', 'air-wp-sync'),
        and: __('And', 'air-wp-sync'),
        or: __('Or', 'air-wp-sync'),
        conjunction: __('Conjunction', 'air-wp-sync'),
        maxNestedFilterGroupReached: __('Filter conditions can only be nested 3 levels deep', 'air-wp-sync'),
        checked: __('Checked', 'air-wp-sync'),
        compare: {
            contains: __('contains...', 'air-wp-sync'),
            does_not_contains: __('does not contain...', 'air-wp-sync'),
            is: __('is...', 'air-wp-sync'),
            is_not: __('is not...', 'air-wp-sync'),
            is_empty: __('is empty', 'air-wp-sync'),
            is_not_empty: __('is not empty', 'air-wp-sync'),
            is_within: __('is within...', 'air-wp-sync'),
            is_before: __('is before...', 'air-wp-sync'),
            is_after: __('is after...', 'air-wp-sync'),
            is_on_or_before: __('is on or before...', 'air-wp-sync'),
            is_on_or_after: __('is on or after...', 'air-wp-sync'),
            is_any_of: __('is any of...', 'air-wp-sync'),
            is_none_of: __('is none of...', 'air-wp-sync'),
            has_any_of: __('has any of...', 'air-wp-sync'),
            has_all_of: __('has all of...', 'air-wp-sync'),
            is_exactly: __('is exactly...', 'air-wp-sync'),
            has_none_of: __('has none of...', 'air-wp-sync'),
            filenames_contains: __('filenames contain...', 'air-wp-sync'),
            has_file_type: __('has file type...', 'air-wp-sync'),
        },
        selectFieldPlaceholder: __('Choose the field', 'air-wp-sync'),
        selectComparisonPlaceholder: __('Choose the condition', 'air-wp-sync'),
        inputValuePlaceholder: __('Set the value', 'air-wp-sync'),
        periods: {
            past_week: __('the past week', 'air-wp-sync'),
            past_month: __('the past month', 'air-wp-sync'),
            past_year: __('the past year', 'air-wp-sync'),
            next_week: __('the next week', 'air-wp-sync'),
            next_month: __('the next month', 'air-wp-sync'),
            next_year: __('the next year', 'air-wp-sync'),
            calendar_week: __('this calendar week', 'air-wp-sync'),
            calendar_month: __('this calendar month', 'air-wp-sync'),
            calendar_year: __('this calendar year', 'air-wp-sync'),
            next_number_of_days: __('the next number of days...', 'air-wp-sync'),
            past_number_of_days: __('the past number of days...', 'air-wp-sync'),
            exact_date: __('exact date...', 'air-wp-sync'),
            today: __('today', 'air-wp-sync'),
            tomorrow: __('tomorrow', 'air-wp-sync'),
            yesterday: __('yesterday', 'air-wp-sync'),
            one_week_ago: __('one week ago', 'air-wp-sync'),
            one_week_from_now: __('one week from now', 'air-wp-sync'),
            one_month_ago: __('one month ago', 'air-wp-sync'),
            one_month_from_now: __('one month from now', 'air-wp-sync'),
            number_of_days_ago: __('number of days ago...', 'air-wp-sync'),
            number_of_days_from_now: __('number of days from now...', 'air-wp-sync'),
        },
        file_types: {
            image: __('image', 'air-wp-sync'),
            text: __('text', 'air-wp-sync'),
        }
    }
};
